@if (!userDetails) {
  <div class="d-flex align-items-end m-b-20">
    <div class="form-group m-r-10 mb-0">
      <label class="t-12 text-muted mb-0" for="emailSearch">{{ "admin_portal.search_by_email" | translate }}</label>
      <div class="d-flex align-items-center">
        <input class="form-control m-r-5" name="emailSearch" id="emailSearch" [placeholder]="'admin_portal.enter_email_placeholder' | translate" [(ngModel)]="queryValue" (keyup.enter)="search()" />
        <button class="btn btn-primary" type="button" (click)="search()">
          <fa-icon [icon]="searching ? 'spinner' : 'search'" [animation]="searching ? 'spin' : undefined"></fa-icon>
        </button>
      </div>
    </div>
  </div>
}
<div>
  @if (pendingAssets?.length && !loading) {
    @for (pendingAsset of pendingAssets; track pendingAsset) {
      <myp-list-item
        [item]="pendingAsset"
        [title]="pendingAsset.user ? pendingAsset.user.firstName + ' ' + pendingAsset.user.lastName + ' (' + pendingAsset.user.email + ')' : 'Unknown User'"
        [collapsible]="true"
        [includeChevron]="false"
        marginBottom="20px"
        (collapsedChanged)="collapsedChanged($event)"
        [showBackground]="true"
        [photo]="pendingAsset.user?.photo || './assets/images/default_avatar.jpg'"
        [subData]="[pendingAsset.product.title]"
      >
        <div class="collapsible-content">
          <div class="row">
            @if (!pendingAsset.loading && assetDetailMap[pendingAsset.asset.assetId]) {
              @if (assetDetailMap[pendingAsset.asset.assetId].product.image) {
                <div class="col-md-3">
                  <img [src]="assetDetailMap[pendingAsset.asset.assetId].product.image" alt="Product Image" class="img-fluid" />
                </div>
              }
              <div [class]="assetDetailMap[pendingAsset.asset.assetId].product.image ? 'col-md-9' : 'col-md-12'">
                <p>
                  {{
                    "admin_portal.eligibility_message"
                      | translate: { firstName: assetDetailMap[pendingAsset.asset.assetId].user.firstName, productTitle: assetDetailMap[pendingAsset.asset.assetId].product.title }
                  }}
                </p>

                @for (eligibleGift of assetDetailMap[pendingAsset.asset.assetId].giveaways; track eligibleGift) {
                  <div class="d-flex align-items-center justify-content-between m-y-20">
                    <strong>{{ eligibleGift.gift.title }}</strong>
                    @if (eligibleGift.redeemed) {
                      <div>
                        <fa-icon icon="circle-check"></fa-icon>
                        <span class="text-muted">{{ "admin_portal.redeemed" | translate }}</span>
                      </div>
                    } @else {
                      <div class="text-nowrap">
                        <button
                          class="btn btn-secondary btn-sm m-r-10"
                          type="button"
                          [disabled]="assetDetailMap[pendingAsset.asset.assetId].rejecting || assetDetailMap[pendingAsset.asset.assetId].redeeming"
                          (click)="rejectGift(eligibleGift, assetDetailMap[pendingAsset.asset.assetId])"
                        >
                          <fa-icon
                            [icon]="assetDetailMap[pendingAsset.asset.assetId].rejecting ? 'spinner' : 'times'"
                            [animation]="assetDetailMap[pendingAsset.asset.assetId].rejecting ? 'spin' : undefined"
                          ></fa-icon>
                          {{ "sphere.workspaces.reject" | translate }}
                        </button>
                        <button
                          class="btn btn-primary btn-sm"
                          type="button"
                          [disabled]="assetDetailMap[pendingAsset.asset.assetId].redeeming || assetDetailMap[pendingAsset.asset.assetId].rejecting"
                          (click)="addGiftToAccount(eligibleGift, assetDetailMap[pendingAsset.asset.assetId])"
                        >
                          <fa-icon
                            [icon]="assetDetailMap[pendingAsset.asset.assetId].redeeming ? 'spinner' : 'plus'"
                            [animation]="assetDetailMap[pendingAsset.asset.assetId].redeeming ? 'spin' : undefined"
                          ></fa-icon>
                          {{ "admin_portal.add_to_account" | translate }}
                        </button>
                      </div>
                    }
                  </div>
                  <hr />
                }
                @if (assetDetailMap[pendingAsset.asset.assetId].allGiftsRedeemed) {
                  <div class="text-end t-14 font-weight-bold">
                    {{ "admin_portal.all_gifts_redeemed_message" | translate }}
                    <br />
                    <br />
                    <button
                      class="btn btn-primary btn-sm"
                      [disabled]="assetDetailMap[pendingAsset.asset.assetId].fulfilling"
                      type="button"
                      (click)="markFulfilled(assetDetailMap[pendingAsset.asset.assetId])"
                    >
                      <fa-icon
                        [icon]="assetDetailMap[pendingAsset.asset.assetId].fulfilling ? 'spinner' : 'check'"
                        [animation]="assetDetailMap[pendingAsset.asset.assetId].fulfilling ? 'spin' : undefined"
                      ></fa-icon>
                      {{ "admin_portal.mark_fulfilled" | translate }}
                    </button>
                  </div>
                }
              </div>
            } @else {
              <myp-skeleton-loader [number]="6" extraContainerClass="m-y-10" [useRandomWidth]="true" type="line"></myp-skeleton-loader>
            }
          </div>
        </div>
      </myp-list-item>
    }
  } @else if (loading) {
    <myp-skeleton-loader type="list-item" [number]="10" extraContainerClass="m-y-20"></myp-skeleton-loader>
  } @else {
    <div class="m-t-30">
      <span class="text-muted">{{ "admin_portal.no_pending_giveaways" | translate }}</span>
    </div>
  }
</div>
